module.exports = __webpack_public_path__ + "img/france-tuberculosis-female.39d42c09.png";